/* Rynoka: toyland-special-pdp.js — behaviour for sections/toyland-special-pdp.liquid.
 *
 * Loaded only by that section, which renders only when custom.special_pdp is true.
 *
 * CART RULE: this file never writes to the cart. Add to Cart buttons click the PDP's
 * real `[data-toyland-main-atc]`, and colour swatches click the real colour radio, so
 * the variant picker, Kaching bundles, the per-order cap and the cart drawer all run
 * exactly as they do from the buy box (see memory add-to-cart-invariants).
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-tl-sp]');
  if (!root) return;

  var form = document.querySelector('[data-toyland-pdp-form]');
  var mainAtc = form && form.querySelector('[data-toyland-main-atc]');

  /* ── Add to Cart: mirror the main button's label, price and availability ── */
  function syncAtc() {
    if (!mainAtc) return;
    var labelEl = mainAtc.querySelector('[data-pdp-atc-label]');
    var priceEl = mainAtc.querySelector('[data-pdp-atc-price]');
    var label = labelEl ? labelEl.textContent.trim() : 'Add to Cart';
    var price = priceEl && !priceEl.hidden ? priceEl.textContent.trim() : '';
    var off = mainAtc.disabled;
    // Document-wide: the Why Rynoka section is a separate section with its own buttons.
    document.querySelectorAll('[data-tl-sp-atc]').forEach(function (btn) {
      var l = btn.querySelector('[data-tl-sp-atc-label]');
      var p = btn.querySelector('[data-tl-sp-price]');
      if (l) l.textContent = label;
      if (p) { p.textContent = price; p.hidden = !price; }
      btn.disabled = off;
    });
    updateOffers();
  }

  if (mainAtc) {
    syncAtc();
    new MutationObserver(syncAtc).observe(mainAtc, {
      attributes: true, childList: true, subtree: true, characterData: true
    });
  }

  document.addEventListener('click', function (e) {
    var atc = e.target.closest('[data-tl-sp-atc]');
    if (!atc) return;
    e.preventDefault();
    if (!mainAtc) return;
    if (mainAtc.disabled) {
      mainAtc.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    mainAtc.click();
  });

  /* ── Colour: swatches drive the real radio; the radio drives the band ── */
  function colourRadio(value) {
    if (!form) return null;
    var radios = form.querySelectorAll('input[type="radio"][name^="options["]');
    for (var i = 0; i < radios.length; i++) {
      var group = radios[i].closest('[data-tl-opt-role]');
      if (group && group.getAttribute('data-tl-opt-role') !== 'color') continue;
      if (radios[i].value === value) return radios[i];
    }
    return null;
  }

  /* Colour controls live in two places: the "Look closer" swatches (story band) and
     the Colours rows of the buy-box Product Details card. Both are painted here. */
  function paintColour(value) {
    var src = null;
    document.querySelectorAll('[data-tl-sp-colour]').forEach(function (b) {
      var on = b.getAttribute('data-tl-sp-colour') === value;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on && !src && b.hasAttribute('data-hex')) src = b;
    });
    var nameEl = root.querySelector('[data-tl-sp-colour-name]');
    if (nameEl) nameEl.textContent = value;
    if (!src) return;
    var hex = src.getAttribute('data-hex');
    if (hex) root.style.setProperty('--sp-band', hex);
    var noteEl = root.querySelector('[data-tl-sp-colour-note]');
    if (noteEl) {
      var note = src.getAttribute('data-note');
      noteEl.textContent = note ? '· ' + note : '';
    }
    var front = root.querySelector('.js-tl-sp-front');
    var img = src.getAttribute('data-front');
    if (front && img && front.getAttribute('src') !== img) {
      front.removeAttribute('srcset');
      front.removeAttribute('sizes');
      front.setAttribute('src', img);
    }
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-tl-sp-colour]');
    if (!sw) return;
    var value = sw.getAttribute('data-tl-sp-colour');
    var radio = colourRadio(value);
    if (radio && !radio.checked) {
      // Buy-box Colours rows behave like the buy box's own swatches (on mobile the page
      // returns to the gallery so the photo swap is seen). The "Look closer" swatches
      // swap their own photo in place, so they tell the buy box not to scroll; click()
      // dispatches `change` synchronously, so the flag is gone right after.
      var quiet = !sw.hasAttribute('data-tl-sp-colour-buybox');
      if (quiet) radio.setAttribute('data-tl-no-scroll', '');
      try { radio.click(); } finally { if (quiet) radio.removeAttribute('data-tl-no-scroll'); }
    }
    paintColour(value);
  });

  if (form) {
    form.addEventListener('change', function (e) {
      var r = e.target;
      if (!r || r.type !== 'radio' || !r.checked) return;
      var group = r.closest('[data-tl-opt-role]');
      if (group && group.getAttribute('data-tl-opt-role') === 'color') paintColour(r.value);
    });
  }

  /* ── Look closer: hotspots + chips share one active index ── */
  var tip = root.querySelector('[data-tl-sp-tip]');
  function setHotspot(i) {
    var src = root.querySelector('[data-tl-sp-hs="' + i + '"]');
    if (!src) return;
    root.querySelectorAll('[data-tl-sp-hs]').forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-tl-sp-hs') === String(i));
    });
    var n = String(Number(i) + 1);
    var set = function (sel, txt) { var el = root.querySelector(sel); if (el) el.textContent = txt; };
    set('[data-tl-sp-detail-n]', n);
    set('[data-tl-sp-detail-n2]', n);
    set('[data-tl-sp-detail-title]', src.getAttribute('data-title'));
    set('[data-tl-sp-detail-desc]', src.getAttribute('data-desc'));
    if (tip) {
      var x = parseFloat(src.getAttribute('data-x'));
      tip.textContent = src.getAttribute('data-title');
      tip.style.left = x + '%';
      tip.style.top = src.getAttribute('data-y') + '%';
      tip.setAttribute('data-align', x > 55 ? 'end' : (x < 40 ? 'start' : 'mid'));
    }
  }
  root.addEventListener('click', function (e) {
    var hs = e.target.closest('[data-tl-sp-hs]');
    if (hs) setHotspot(hs.getAttribute('data-tl-sp-hs'));
  });
  setHotspot(0);

  /* ── Reviews rail arrows ── */
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tl-sp-rev]');
    if (!b) return;
    var rail = root.querySelector('[data-tl-sp-rev-rail]');
    if (rail) rail.scrollBy({ left: Number(b.getAttribute('data-tl-sp-rev')) * rail.clientWidth * 0.8, behavior: 'smooth' });
  });

  /* ── Videos: tap to play WITH SOUND / pause, one at a time ──
     The tag ships muted (an unmuted <video> may not even load a poster on iOS), and
     is unmuted inside the tap handler: a user gesture is what lets the browser play
     audio. If the browser still refuses sound, it falls back to muted playback rather
     than doing nothing. Anything playing pauses itself once it scrolls mostly out of
     view or the tab is hidden. */
  function stopVideo(v) {
    if (!v.paused) v.pause();
    var c = v.closest('[data-tl-sp-video]');
    if (c) c.classList.remove('is-playing');
  }
  function stopAll(except) {
    root.querySelectorAll('[data-tl-sp-video] video').forEach(function (o) {
      if (o !== except) stopVideo(o);
    });
  }

  root.addEventListener('click', function (e) {
    var card = e.target.closest('[data-tl-sp-video]');
    if (!card) return;
    var v = card.querySelector('video');
    if (!v) return;
    if (v.paused) {
      stopAll(v);
      v.muted = false;
      v.volume = 1;
      card.classList.add('is-playing');
      var p = v.play();
      if (p && p.catch) {
        p.catch(function () {
          v.muted = true;
          var p2 = v.play();
          if (p2 && p2.catch) p2.catch(function () { card.classList.remove('is-playing'); });
        });
      }
    } else {
      stopVideo(v);
    }
  });

  if (typeof window.IntersectionObserver === 'function') {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.intersectionRatio < 0.5) {
          var v = en.target.querySelector('video');
          if (v) stopVideo(v);
        }
      });
    }, { threshold: [0, 0.5] });
    root.querySelectorAll('[data-tl-sp-video]').forEach(function (c) { vio.observe(c); });
  }
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stopAll(null);
  });

  /* ── Product Details card: clamp long rows to 2 lines, "Read more" only if clipped ── */
  function initReadMore() {
    document.querySelectorAll('[data-tl-sd-row]').forEach(function (row) {
      var val = row.querySelector('[data-tl-sd-value]');
      var btn = row.querySelector('[data-tl-sd-more]');
      if (!val || !btn || row.classList.contains('is-open')) return;
      btn.hidden = !(val.scrollHeight > val.clientHeight + 1);
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tl-sd-more]');
    if (!btn) return;
    var row = btn.closest('[data-tl-sd-row]');
    var open = !row.classList.contains('is-open');
    row.classList.toggle('is-open', open);
    btn.textContent = open ? 'Read less' : 'Read more';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  initReadMore();
  window.addEventListener('resize', initReadMore);
  window.addEventListener('load', initReadMore);

  /* ── Offers for you: best code for THIS order + price after it ──
     The base is the live Add to Cart total (it already follows the variant, quantity
     and any Kaching bundle), read from the main button so it can never disagree with
     what the cart will charge. Saving per code: flat = amount, percent = round(base ×
     amount / 100); only codes whose minimum the base meets are eligible. */
  function updateOffers() {
    var sec = document.querySelector('[data-tl-sp-offers]');
    if (!sec || !mainAtc) return;
    var priceEl = mainAtc.querySelector('[data-pdp-atc-price]');
    var txt = priceEl ? priceEl.textContent.trim() : '';
    /* Read the first number only. On a combo page Kaching writes the label as
       "Rs. 599.00"; stripping every non-digit but "." turned that into ".599.00"
       (= 0.599, shown as "Rs.1"). Always print ₹, like the coupon tickets. */
    var num = txt.match(/\d[\d,]*(?:\.\d+)?/);
    var base = num ? parseFloat(num[0].replace(/,/g, '')) || 0 : 0;
    var sym = '₹';
    var fmt = function (n) { return sym + Math.round(n).toLocaleString('en-IN'); };
    var best = null, bestSave = 0;
    sec.querySelectorAll('[data-tl-sp-offer]').forEach(function (t) {
      var amt = parseFloat(t.getAttribute('data-amount')) || 0;
      var min = parseFloat(t.getAttribute('data-min')) || 0;
      var save = t.getAttribute('data-type') === 'pct' ? Math.round(base * amt / 100) : amt;
      if (base > 0 && base >= min && save > bestSave) { best = t; bestSave = save; }
    });
    sec.querySelectorAll('[data-tl-sp-offer]').forEach(function (t) {
      t.classList.toggle('is-best', t === best);
    });
    var sum = sec.querySelector('[data-tl-sp-offer-sum]');
    if (!sum) return;
    var set = function (sel, v) { var el = sum.querySelector(sel); if (el) el.textContent = v; };
    sum.classList.toggle('has-best', !!best);
    set('[data-tl-sp-offer-was]', base ? fmt(base) : '');
    if (best) {
      set('[data-tl-sp-offer-now]', fmt(Math.max(0, base - bestSave)));
      set('[data-tl-sp-offer-code]', best.getAttribute('data-code'));
    }
  }

  var toastTimer = null;
  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (resolve) {
      var ta = document.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', '');
      ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (err) {}
      document.body.removeChild(ta); resolve();
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tl-sp-copy]');
    if (!btn) return;
    var code = btn.getAttribute('data-tl-sp-copy');
    var done = function () {
      var label = btn.querySelector('[data-tl-sp-copy-label]');
      btn.classList.add('is-copied');
      if (label) label.textContent = 'Copied';
      clearTimeout(btn._tlT);
      btn._tlT = setTimeout(function () {
        btn.classList.remove('is-copied');
        if (label) label.textContent = 'Copy';
      }, 2000);
      var toast = document.querySelector('[data-tl-sp-toast]');
      if (toast) {
        var t = toast.querySelector('[data-tl-sp-toast-text]');
        if (t) t.textContent = code + ' copied. Apply at checkout.';
        toast.hidden = false;
        clearTimeout(toastTimer);
        toastTimer = setTimeout(function () { toast.hidden = true; }, 2000);
      }
    };
    var p = copyText(code);
    if (p && p.then) p.then(done, done); else done();
  });
  updateOffers();

  /* ── Reveal on scroll (content is visible without JS; this only animates) ── */
  if (typeof window.IntersectionObserver === 'function' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.15 });
    root.classList.add('tl-sp--reveal');
    document.querySelectorAll('[data-tl-sp-reveal]').forEach(function (el) { io.observe(el); });
    document.querySelectorAll('.tl-sp').forEach(function (el) { el.classList.add('tl-sp--reveal'); });
  }
})();
